/**
 * Zeniora Promo Engine - UI Widget 渲染组件 (响应式多轨滑动同步版)
 * 
 * 职责：
 * 1. 渲染双节点里程碑进度条 (PromoProgressBar)，支持留空配置。
 * 2. 渲染 PDP 页面高转化 BOGO 联合加购盒子 (PdpBundleWidget)，PC端采用 side-by-side 按钮切换，移动端采用垂直堆叠 + 配件横向卡片轻按激活高亮。
 * 3. 渲染 Cart Drawer 内凑单区 (CartUpsellWidget)，PC端显示左右雪佛龙平滑控制，移动端完全隐藏箭头并启用原生 touch 惯性弹性滑动。
 */

(function () {
  const formatMoney = (cents) => {
    const symbol = window.ZenioraPromoConfig?.generalSettings?.currencySymbol || '$';
    const amount = (cents / 100).toFixed(2);
    return `${symbol}${amount}`;
  };

  const getSizedImageUrl = (src, size = '240x240_crop_center') => {
    if (!src) return '//cdn.shopify.com/s/images/themes/product-1.png';
    if (src.indexOf('cdn.shopify.com') === -1) return src;
    const parts = src.split('?');
    let baseUrl = parts[0];
    const query = parts[1] ? `?${parts[1]}` : '';
    const sizePattern = /_(?:pico|icon|thumb|small|compact|medium|large|grand|1024x1024|2048x2048|master|(?:\d+x\d*)|(?:\d*x\d+))(_crop_[a-z]+)?/g;
    baseUrl = baseUrl.replace(sizePattern, '');
    const lastDot = baseUrl.lastIndexOf('.');
    if (lastDot === -1) return src;
    const ext = baseUrl.substring(lastDot);
    const pathWithoutExt = baseUrl.substring(0, lastDot);
    return `${pathWithoutExt}_${size}${ext}${query}`;
  };

  window.ZenioraPromoWidgets = {
    // ----------------------------------------------------
    // 1. 渲染双节点里程碑进度条 (Milestone Progress Bar)
    // ----------------------------------------------------
    renderProgressBar: function (container, promoState, cartData, activeRule) {
      if (!container) return;

      const configLang = window.ZenioraPromoConfig?.languageSettings?.progressBar || {};
      const threshold = window.ZenioraPromoConfig?.freeShipping?.threshold || 5900;
      const total = cartData?.total_price || 0;

      let progressPct = 0;
      let barClass = '';
      let promoText = '';
      let iconSvg = '';
      let milestoneHtml = '';

      const rawIncompleteText = configLang.shippingIncompletePrefix ?? 'Only {remaining} away from FREE SHIPPING!';
      const rawSuccessText = configLang.shippingSuccessNotice ?? 'Congrats! You\'ve unlocked FREE SHIPPING!';

      // 完美的卡车矢量 SVG (Feather 图标标准规范，绝无多余重叠线)
      const truckSvg = `<svg class="zeniora-promo-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="3" width="15" height="13" rx="2" ry="2" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" /></svg>`;
      const successSvg = `<svg class="zeniora-promo-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M22 4L12 14.01l-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

      if (promoState === 'INCOMPLETE_B2G1' && activeRule) {
        const triggerQty = activeRule.totalTriggerQty || 1;
        const remainingQty = Math.max(0, 3 - triggerQty);

        progressPct = triggerQty === 1 ? 33.3 : 66.7;
        barClass = 'zeniora-bar--b2g1';

        // 动态将文案中的 {count} 替换为剩余件数
        const rawNotice = activeRule.cartNotice ?? configLang.b2g1Incomplete ?? '';
        promoText = rawNotice.replace('{count}', `<strong class="zeniora-highlight">${remainingQty}</strong>`);

        iconSvg = `<svg class="zeniora-promo-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 12V20H4V12M22 7H2V12H22V7ZM12 7C12 7 12 3 9.5 3C7 3 7 6 9.5 7H12ZM12 7C12 7 12 3 14.5 3C17 3 17 6 14.5 7H12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

        // B2G1 三阶段里程碑节点（33.3%、66.7%、100%）
        milestoneHtml = `
          <div class="zeniora-milestone zeniora-milestone--reached" style="left: 33.3%;">
            <span class="zeniora-milestone__dot"></span>
          </div>
          <div class="zeniora-milestone ${triggerQty >= 2 ? 'zeniora-milestone--reached' : ''}" style="left: 66.7%;">
            <span class="zeniora-milestone__dot"></span>
          </div>
          <div class="zeniora-milestone" style="left: 100%;">
            <span class="zeniora-milestone__dot"></span>
          </div>
        `;
      } else if (promoState === 'INCOMPLETE_SHIPPING') {
        barClass = 'zeniora-bar--shipping';
        const remaining = threshold - total;
        progressPct = Math.min((total / threshold) * 100, 99);

        promoText = rawIncompleteText.replace('{remaining}', `<strong class="zeniora-highlight">${formatMoney(remaining)}</strong>`);
        iconSvg = truckSvg;

        milestoneHtml = `
          <div class="zeniora-milestone" style="left: 100%;">
            <span class="zeniora-milestone__dot"></span>
          </div>
        `;
      } else if (promoState === 'ALL_SUCCESS') {
        container.innerHTML = '';
        container.classList.remove('zeniora-active');
        return;
      } else {
        container.innerHTML = '';
        container.classList.remove('zeniora-active');
        return;
      }

      container.classList.add('zeniora-active');
      container.innerHTML = `
        <div class="zeniora-promo-bar__container">
          <div class="zeniora-promo-bar__header">
            ${iconSvg}
            <span class="zeniora-promo-bar__text">${promoText}</span>
          </div>
          <div class="zeniora-promo-bar__track">
            <div class="zeniora-promo-bar__fill ${barClass}" style="width: ${progressPct}%"></div>
            <div class="zeniora-promo-bar__milestones">
              ${milestoneHtml}
            </div>
          </div>
        </div>
      `;
    },

    // ----------------------------------------------------
    // 2. 渲染购物车凑单/配对加购 Widget (双端自适应滑动)
    // ----------------------------------------------------
    renderCartUpsell: function (container, promoState, recommendations, cartData) {
      if (!container) return;

      if (!recommendations || recommendations.length === 0) {
        container.innerHTML = '';
        container.classList.remove('zeniora-active');
        return;
      }

      const configLang = window.ZenioraPromoConfig?.languageSettings?.cartUpsell || {};
      container.classList.add('zeniora-active');

      const titleText = configLang.b2g1Title || configLang.shippingTitle || 'You Might Also Like';
      const subtitleText = configLang.b2g1Subtitle || configLang.shippingSubtitle || '';
      const layoutClass = 'zeniora-upsell--standard';

      const addBtnText = configLang.addButtonText ?? '';

      // 1. 拼接多商品卡片
      const cardsHtml = recommendations.map((prod, index) => {
        const hasVariants = prod.variants && prod.variants.length > 1;
        const defaultVariant = prod.variants ? prod.variants[0] : prod;
        const imgUrl = getSizedImageUrl(prod.featured_image || prod.images?.[0], '240x240_crop_center');

        let priceHtml = '';
        const originalPrice = defaultVariant.price;
        const comparePrice = defaultVariant.compare_at_price || originalPrice;
        if (comparePrice > originalPrice) {
          priceHtml = `
            <span class="zeniora-item__price">${formatMoney(originalPrice)}</span>
            <span class="zeniora-item__price zeniora-item__price--compare">${formatMoney(comparePrice)}</span>
          `;
        } else {
          priceHtml = `<span class="zeniora-item__price">${formatMoney(originalPrice)}</span>`;
        }

        return `
          <div class="zeniora-upsell__item" data-index="${index}">
            <div class="zeniora-item__media">
              <a href="${prod.url || '/products/' + prod.handle}">
                <responsive-image class="m-image m-image-loaded" style="--aspect-ratio: 1.0" intersecting="true">
                  <img id="Img_${index}" src="${imgUrl}" alt="${prod.title}" loading="lazy" />
                </responsive-image>
              </a>
            </div>
            <div class="zeniora-item__info">
              <h4 class="zeniora-item__title" title="${prod.title}">
                <a href="${prod.url || '/products/' + prod.handle}" class="zeniora-item__title-link">${prod.title}</a>
              </h4>
              <div class="zeniora-item__price-row" id="Price_${index}">
                ${priceHtml}
              </div>
              
              <!-- 变体下拉选择框 -->
              ${hasVariants ? `
                <div class="zeniora-item__variant-container">
                  <select class="zeniora-item__variant-select" id="VariantSelect_${index}">
                    ${prod.variants.map((v, vIdx) => `
                      <option value="${v.id}" ${vIdx === 0 ? 'selected' : ''}>
                        ${v.title}
                      </option>
                    `).join('')}
                  </select>
                </div>
              ` : ''}
            </div>
            <button class="zeniora-item__btn-add m-spinner-button m-button m-button--secondary m:w-full" id="AddBtn_${index}" data-variant-id="${defaultVariant.id}">
              <span class="m-spinner-icon">
                <svg class="animate-spin m-svg-icon--medium" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
              <span class="m-add-to-cart--text">${addBtnText}</span>
            </button>
          </div>
        `;
      }).join('');

      // 2. 渲染外壳结构
      container.innerHTML = `
        <div class="zeniora-upsell__container ${layoutClass}">
          <div class="zeniora-upsell__header">
            <h3 class="zeniora-upsell__title">${titleText}</h3>
            ${subtitleText ? `<p class="zeniora-upsell__subtitle">${subtitleText}</p>` : ''}
          </div>
          <div class="zeniora-upsell__slider-wrapper">
            ${recommendations.length > 1 ? `
              <button class="zeniora-upsell-arrow zeniora-upsell-arrow--prev" aria-label="Scroll left" type="button">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
              </button>
            ` : ''}
            
            <div class="zeniora-upsell__list" id="ZenioraUpsellScrollList">
              ${cardsHtml}
            </div>

            ${recommendations.length > 1 ? `
              <button class="zeniora-upsell-arrow zeniora-upsell-arrow--next" aria-label="Scroll right" type="button">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
              </button>
            ` : ''}
          </div>
        </div>
      `;

      const listEl = container.querySelector('#ZenioraUpsellScrollList');
      const prevBtn = container.querySelector('.zeniora-upsell-arrow--prev');
      const nextBtn = container.querySelector('.zeniora-upsell-arrow--next');

      if (listEl) {
        // 阻止侧滑手势冲突
        listEl.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true });
        listEl.addEventListener('touchmove', (e) => e.stopPropagation(), { passive: true });

        // 绑定 PC 端雪佛龙箭头程序滑动动画 (卡片 140px + gap 12px = 152px)
        if (prevBtn) {
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            listEl.scrollBy({ left: -152, behavior: 'smooth' });
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            listEl.scrollBy({ left: 152, behavior: 'smooth' });
          });
        }
      }

      // 3. 循环绑定变体更改监听
      recommendations.forEach((prod, index) => {
        const selectEl = container.querySelector(`#VariantSelect_${index}`);
        if (selectEl) {
          selectEl.addEventListener('change', () => {
            const selectedVariantId = parseInt(selectEl.value);
            const foundVariant = prod.variants.find(v => v.id === selectedVariantId);

            // 联动更新对应卡片的加购 variantId
            const addBtn = container.querySelector(`#AddBtn_${index}`);
            if (addBtn) addBtn.dataset.variantId = selectEl.value;

            if (foundVariant) {
              // 联动变体图片
              const imgEl = container.querySelector(`#Img_${index}`);
              if (imgEl) {
                const newImg = foundVariant.featured_image ? (typeof foundVariant.featured_image === 'string' ? foundVariant.featured_image : foundVariant.featured_image.src) : null;
                if (newImg) imgEl.src = getSizedImageUrl(newImg, '240x240_crop_center');
              }

              // 联动变体价格
              const priceRow = container.querySelector(`#Price_${index}`);
              if (priceRow) {
                const originalPrice = foundVariant.price;
                const comparePrice = foundVariant.compare_at_price || originalPrice;
                if (comparePrice > originalPrice) {
                  priceRow.innerHTML = `
                     <span class="zeniora-item__price">${formatMoney(originalPrice)}</span>
                     <span class="zeniora-item__price zeniora-item__price--compare">${formatMoney(comparePrice)}</span>
                   `;
                } else {
                  priceRow.innerHTML = `<span class="zeniora-item__price">${formatMoney(originalPrice)}</span>`;
                }
              }
            }
          });
        }
      });

      // 4. 循环绑定加购点击监听
      recommendations.forEach((prod, index) => {
        const addBtn = container.querySelector(`#AddBtn_${index}`);
        if (addBtn) {
          addBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            const variantId = addBtn.dataset.variantId;
            if (!variantId) return;

            addBtn.classList.add('m-spinner-loading');
            addBtn.setAttribute('disabled', 'disabled');

            if (window.ZenioraPromoEngineInstance?.addItemsToCart) {
              await window.ZenioraPromoEngineInstance.addItemsToCart([
                { id: parseInt(variantId), quantity: 1 }
              ]);
            }

            addBtn.classList.remove('m-spinner-loading');
            addBtn.removeAttribute('disabled');
          });
        }
      });
    },

    // ----------------------------------------------------
    // 3. 渲染 PDP 页面 B2G1 联合加购盒子 (黄金三件套)
    // ----------------------------------------------------
    renderPdpWidget: function (container, matchedRule, primaryProduct, recommendedProducts) {
      if (!container || !matchedRule || !primaryProduct || !recommendedProducts || recommendedProducts.length === 0) return;

      const configLang = window.ZenioraPromoConfig?.languageSettings?.pdpBundle || {};

      const badgeText = configLang.badgeText ?? 'B2G1';
      const primaryLabel = configLang.primaryLabel ?? 'This Item';
      const pairedLabel = configLang.pairedLabel ?? 'Recommended';
      const summaryLabel = configLang.summaryLabel ?? 'Bundle Offer Price:';
      const buyButtonText = matchedRule.pdpButtonText ?? configLang.buyButtonText ?? 'Add Bundle to Cart';

      const primaryImg = getSizedImageUrl(primaryProduct.featured_image || primaryProduct.images?.[0], '240x240_crop_center');

      // 配件卡片 HTML 生成器
      const renderAccessoryCard = (prod, idx) => {
        const hasVariants = prod.variants && prod.variants.length > 1;
        const imgUrl = getSizedImageUrl(prod.featured_image || prod.images?.[0], '240x240_crop_center');

        return `
          <div class="zeniora-bundle-card zeniora-bundle-card--accessory" data-index="${idx}">
            <div class="zeniora-bundle-card__img-container">
              <a href="${prod.url || '/products/' + prod.handle}" target="_blank">
                <responsive-image class="m-image m-image-loaded" style="--aspect-ratio: 1.0" intersecting="true">
                  <img id="PdpAccImg_${idx}" src="${imgUrl}" alt="${prod.title}" />
                </responsive-image>
              </a>
            </div>
            <div class="zeniora-bundle-card__meta">
              <h4 class="zeniora-title" title="${prod.title}">
                <a href="${prod.url || '/products/' + prod.handle}" target="_blank" class="zeniora-title__link">${prod.title}</a>
              </h4>
              <div class="zeniora-price-container" id="PdpAccPriceContainer_${idx}"></div>
              
              ${hasVariants ? `
                <div class="zeniora-bundle-card__variant-wrapper">
                  <select class="zeniora-bundle-card__variant-select" id="PdpAccVariantSelect_${idx}">
                    ${prod.variants.map((v, vIdx) => `
                      <option value="${v.id}" data-price="${v.price}" ${vIdx === 0 ? 'selected' : ''}>
                        ${v.title}
                      </option>
                    `).join('')}
                  </select>
                </div>
              ` : ''}
            </div>
          </div>
        `;
      };

      // 1. 渲染统一的 HTML 外壳
      container.innerHTML = `
        <div class="zeniora-pdp-bundle">
          <!-- 顶部 Notice 栏 -->
          <div class="zeniora-pdp-bundle__notice">
            <p>${matchedRule.pdpNotice ?? ''}</p>
          </div>
          
          <!-- 主体卡片并排/垂直堆叠容器 -->
          <div class="zeniora-pdp-bundle__items-container">
            <!-- 主商品卡片 -->
            <div class="zeniora-bundle-card zeniora-bundle-card--primary">
              <div class="zeniora-bundle-card__img-container">
                <responsive-image class="m-image m-image-loaded" style="--aspect-ratio: 1.0" intersecting="true">
                  <img id="ZenioraPdpPrimaryImg" src="${primaryImg}" alt="${primaryProduct.title}" />
                </responsive-image>
              </div>
              <div class="zeniora-bundle-card__meta">
                <h4 class="zeniora-title zeniora-title--primary" title="${primaryProduct.title}">
                  <strong class="zeniora-title__prefix">${primaryLabel}:</strong> ${primaryProduct.title}
                </h4>
                <div class="zeniora-price-container" id="PdpPrimaryPriceContainer"></div>
              </div>
            </div>
            
            <!-- 第一个配件 -->
            ${recommendedProducts.length > 0 ? `
              <div class="zeniora-bundle-plus">+</div>
              ${renderAccessoryCard(recommendedProducts[0], 0)}
            ` : ''}
            
            <!-- 第二个配件 -->
            ${recommendedProducts.length > 1 ? `
              <div class="zeniora-bundle-plus">+</div>
              ${renderAccessoryCard(recommendedProducts[1], 1)}
            ` : ''}
          </div>
          
          <!-- 统一底栏结算区 -->
          <div class="zeniora-pdp-bundle__footer">
            <div class="zeniora-bundle__pricing">
              <div class="zeniora-bundle__summary-text">${summaryLabel}</div>
              <div class="zeniora-bundle__price-group">
                <span class="zeniora-bundle__price-promo" id="PdpBundlePromoTotalDisplay">--</span>
                <span class="zeniora-bundle__price-compare" id="PdpBundleCompareTotalDisplay">--</span>
                <span class="m-product-tag m-product-tag--sale m-gradient m-color-badge-sale zeniora-bundle__save-badge" id="PdpBundleSavePercentDisplay"></span>
              </div>
            </div>
            <button class="zeniora-bundle__btn-buy m-spinner-button m-button m-button--primary" id="ZenioraPdpAddBundleBtn">
              <span class="m-spinner-icon">
                <svg class="animate-spin m-svg-icon--medium" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
              <span class="m-add-to-cart--text">${buyButtonText}</span>
            </button>
          </div>
        </div>
      `;

      // 2. 动态核价函数
      const updateMixAndMatchPricing = () => {
        let P1 = primaryProduct.price;
        let primaryImgUrl = getSizedImageUrl(primaryProduct.featured_image || primaryProduct.images?.[0], '240x240_crop_center');

        // 联动 1：主戒指原生加购变体 ID 监听
        const mainVariantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        if (mainVariantInput && primaryProduct.variants) {
          const currentId = parseInt(mainVariantInput.value);
          const found = primaryProduct.variants.find(v => v.id === currentId);
          if (found) {
            P1 = found.price;
            if (found.featured_image) {
              primaryImgUrl = getSizedImageUrl(typeof found.featured_image === 'string' ? found.featured_image : found.featured_image.src, '240x240_crop_center');
            }
          }
        }

        // 联动 2：读取配件 A 价格
        let P2 = 0;
        let acc1VariantId = null;
        if (recommendedProducts.length > 0) {
          const acc1 = recommendedProducts[0];
          const acc1Select = container.querySelector('#PdpAccVariantSelect_0');
          if (acc1Select) {
            P2 = parseInt(acc1Select.options[acc1Select.selectedIndex].dataset.price);
            acc1VariantId = parseInt(acc1Select.value);
          } else {
            const acc1Default = acc1.variants?.[0] || acc1;
            P2 = acc1Default.price;
            acc1VariantId = acc1Default.id;
          }

          // 同步配件 A 变体图
          const acc1ImgEl = container.querySelector('#PdpAccImg_0');
          if (acc1ImgEl && acc1.variants) {
            const foundAcc1 = acc1.variants.find(v => v.id === acc1VariantId);
            if (foundAcc1 && foundAcc1.featured_image) {
              const src = getSizedImageUrl(typeof foundAcc1.featured_image === 'string' ? foundAcc1.featured_image : foundAcc1.featured_image.src, '240x240_crop_center');
              const currentSrc = acc1ImgEl.getAttribute('src');
              if (currentSrc !== src) acc1ImgEl.src = src;
            }
          }
        }

        // 联动 3：读取配件 B 价格
        let P3 = 0;
        let acc2VariantId = null;
        if (recommendedProducts.length > 1) {
          const acc2 = recommendedProducts[1];
          const acc2Select = container.querySelector('#PdpAccVariantSelect_1');
          if (acc2Select) {
            P3 = parseInt(acc2Select.options[acc2Select.selectedIndex].dataset.price);
            acc2VariantId = parseInt(acc2Select.value);
          } else {
            const acc2Default = acc2.variants?.[0] || acc2;
            P3 = acc2Default.price;
            acc2VariantId = acc2Default.id;
          }

          // 同步配件 B 变体图
          const acc2ImgEl = container.querySelector('#PdpAccImg_1');
          if (acc2ImgEl && acc2.variants) {
            const foundAcc2 = acc2.variants.find(v => v.id === acc2VariantId);
            if (foundAcc2 && foundAcc2.featured_image) {
              const src = getSizedImageUrl(typeof foundAcc2.featured_image === 'string' ? foundAcc2.featured_image : foundAcc2.featured_image.src, '240x240_crop_center');
              const currentSrc = acc2ImgEl.getAttribute('src');
              if (currentSrc !== src) acc2ImgEl.src = src;
            }
          }
        }

        // 3. 计算 B2G1 优惠后的价格
        const totalOriginal = P1 + P2 + P3;
        let totalPromo = totalOriginal;
        let savePercent = 0;

        if (recommendedProducts.length >= 2) {
          // 凑齐 3 件（主商品 + 配件 A + 配件 B），触发最便宜的一件免费
          const minPrice = Math.min(P1, P2, P3);
          totalPromo = totalOriginal - minPrice;

          if (totalOriginal > 0) {
            savePercent = Math.round((minPrice / totalOriginal) * 100);
          }

          // 给最便宜的那件卡片显示 FREE
          const primaryContainer = container.querySelector('#PdpPrimaryPriceContainer');
          const acc1Container = container.querySelector('#PdpAccPriceContainer_0');
          const acc2Container = container.querySelector('#PdpAccPriceContainer_1');

          if (minPrice === P1) {
            if (primaryContainer) primaryContainer.innerHTML = `<span class="zeniora-price">${formatMoney(0)}</span> <span class="zeniora-price zeniora-price--compare">${formatMoney(P1)}</span>`;
            if (acc1Container) acc1Container.innerHTML = `<span class="zeniora-price">${formatMoney(P2)}</span>`;
            if (acc2Container) acc2Container.innerHTML = `<span class="zeniora-price">${formatMoney(P3)}</span>`;
          } else if (minPrice === P2) {
            if (primaryContainer) primaryContainer.innerHTML = `<span class="zeniora-price">${formatMoney(P1)}</span>`;
            if (acc1Container) acc1Container.innerHTML = `<span class="zeniora-price">${formatMoney(0)}</span> <span class="zeniora-price zeniora-price--compare">${formatMoney(P2)}</span>`;
            if (acc2Container) acc2Container.innerHTML = `<span class="zeniora-price">${formatMoney(P3)}</span>`;
          } else {
            if (primaryContainer) primaryContainer.innerHTML = `<span class="zeniora-price">${formatMoney(P1)}</span>`;
            if (acc1Container) acc1Container.innerHTML = `<span class="zeniora-price">${formatMoney(P2)}</span>`;
            if (acc2Container) acc2Container.innerHTML = `<span class="zeniora-price">${formatMoney(0)}</span> <span class="zeniora-price zeniora-price--compare">${formatMoney(P3)}</span>`;
          }
        } else if (recommendedProducts.length === 1) {
          // 只有 1 个推荐产品时（凑齐 2 件，不享受 B2G1 优惠）
          totalPromo = P1 + P2;
          const primaryContainer = container.querySelector('#PdpPrimaryPriceContainer');
          const acc1Container = container.querySelector('#PdpAccPriceContainer_0');
          if (primaryContainer) primaryContainer.innerHTML = `<span class="zeniora-price">${formatMoney(P1)}</span>`;
          if (acc1Container) acc1Container.innerHTML = `<span class="zeniora-price">${formatMoney(P2)}</span>`;
        } else {
          // 只有 0 个推荐产品
          totalPromo = P1;
          const primaryContainer = container.querySelector('#PdpPrimaryPriceContainer');
          if (primaryContainer) primaryContainer.innerHTML = `<span class="zeniora-price">${formatMoney(P1)}</span>`;
        }

        // 刷新底栏总价
        const bundlePromoDisplay = container.querySelector('#PdpBundlePromoTotalDisplay');
        const bundleCompareDisplay = container.querySelector('#PdpBundleCompareTotalDisplay');
        const savePercentDisplay = container.querySelector('#PdpBundleSavePercentDisplay');

        if (bundlePromoDisplay) bundlePromoDisplay.textContent = formatMoney(totalPromo);
        if (bundleCompareDisplay) bundleCompareDisplay.textContent = formatMoney(totalOriginal);

        if (savePercentDisplay) {
          if (savePercent > 0) {
            savePercentDisplay.textContent = `Save ${savePercent}%`;
            savePercentDisplay.style.display = 'inline-block';
          } else {
            savePercentDisplay.style.display = 'none';
          }
        }

        // 同步主商品图
        const primaryImgEl = container.querySelector('#ZenioraPdpPrimaryImg');
        if (primaryImgEl && primaryImgUrl && primaryImgEl.src !== primaryImgUrl) {
          primaryImgEl.src = primaryImgUrl;
        }
      };

      // 3. 监听配件变体下拉框切换
      const acc1Select = container.querySelector('#PdpAccVariantSelect_0');
      if (acc1Select) {
        acc1Select.addEventListener('change', updateMixAndMatchPricing);
      }
      const acc2Select = container.querySelector('#PdpAccVariantSelect_1');
      if (acc2Select) {
        acc2Select.addEventListener('change', updateMixAndMatchPricing);
      }

      // 4. 监听原生 PDP 加购表单变体切换
      const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
      if (mainForm) {
        mainForm.addEventListener('change', updateMixAndMatchPricing);
      }

      // 5. 初始化核价与图效
      updateMixAndMatchPricing();

      // 6. 一键 Bundle 加购事件绑定
      const buyButton = container.querySelector('#ZenioraPdpAddBundleBtn');
      if (buyButton) {
        buyButton.addEventListener('click', async (e) => {
          e.preventDefault();

          const primaryVariantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
          const primaryVariant = primaryProduct.variants?.[0] || primaryProduct;
          const finalPrimaryVariantId = primaryVariantInput ? parseInt(primaryVariantInput.value) : primaryVariant.id;

          const itemsToCart = [{ id: finalPrimaryVariantId, quantity: 1 }];

          if (recommendedProducts.length > 0) {
            const selectAcc1 = container.querySelector('#PdpAccVariantSelect_0');
            const acc1Id = selectAcc1 ? parseInt(selectAcc1.value) : recommendedProducts[0].variants?.[0]?.id || recommendedProducts[0].id;
            itemsToCart.push({ id: acc1Id, quantity: 1 });
          }

          if (recommendedProducts.length > 1) {
            const selectAcc2 = container.querySelector('#PdpAccVariantSelect_1');
            const acc2Id = selectAcc2 ? parseInt(selectAcc2.value) : recommendedProducts[1].variants?.[0]?.id || recommendedProducts[1].id;
            itemsToCart.push({ id: acc2Id, quantity: 1 });
          }

          buyButton.classList.add('m-spinner-loading');
          buyButton.setAttribute('disabled', 'disabled');

          if (window.ZenioraPromoEngineInstance?.addItemsToCart) {
            await window.ZenioraPromoEngineInstance.addItemsToCart(itemsToCart);
          }

          buyButton.classList.remove('m-spinner-loading');
          buyButton.removeAttribute('disabled');
        });
      }

      // 7. 点击 This Item 主商品卡片平滑滚动至页首
      const primaryCard = container.querySelector('.zeniora-bundle-card--primary');
      if (primaryCard) {
        primaryCard.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },

    // ----------------------------------------------------
    // 4. 渲染 PDP 骨架屏 (Skeleton Loading State)
    // ----------------------------------------------------
    renderPdpSkeleton: function (container) {
      if (!container) return;
      container.classList.add('zeniora-active');

      const shimmerEl = (width, height, margin = '0') => `
        <div class="zeniora-shimmer-bg" style="width: ${width}; height: ${height}; border-radius: 4px; margin: ${margin};"></div>
      `;

      container.innerHTML = `
        <div class="zeniora-pdp-bundle zeniora-pdp-bundle--skeleton">
          <!-- 顶部 Notice 骨架 -->
          <div class="zeniora-pdp-bundle__notice">
            ${shimmerEl('220px', '18px')}
          </div>
          
          <!-- 主体卡片容器 -->
          <div class="zeniora-pdp-bundle__items-container">
            <!-- 主商品骨架 -->
            <div class="zeniora-bundle-card zeniora-bundle-card--primary">
              <div class="zeniora-bundle-card__img-container zeniora-shimmer-bg"></div>
              <div class="zeniora-bundle-card__meta">
                ${shimmerEl('100%', '14px', '0 0 4px 0')}
                ${shimmerEl('70%', '14px')}
              </div>
            </div>
            
            <div class="zeniora-bundle-plus">+</div>
            
            <!-- 配件一骨架 -->
            <div class="zeniora-bundle-card zeniora-bundle-card--accessory">
              <div class="zeniora-bundle-card__img-container zeniora-shimmer-bg"></div>
              <div class="zeniora-bundle-card__meta">
                ${shimmerEl('100%', '14px', '0 0 4px 0')}
                ${shimmerEl('70%', '14px')}
              </div>
            </div>
            
            <div class="zeniora-bundle-plus">+</div>
            
            <!-- 配件二骨架 -->
            <div class="zeniora-bundle-card zeniora-bundle-card--accessory">
              <div class="zeniora-bundle-card__img-container zeniora-shimmer-bg"></div>
              <div class="zeniora-bundle-card__meta">
                ${shimmerEl('100%', '14px', '0 0 4px 0')}
                ${shimmerEl('70%', '14px')}
              </div>
            </div>
          </div>
          
          <!-- 底栏结算骨架 -->
          <div class="zeniora-pdp-bundle__footer">
            <div class="zeniora-bundle__pricing">
              ${shimmerEl('80px', '12px', '0 0 4px 0')}
              ${shimmerEl('110px', '20px')}
            </div>
            ${shimmerEl('150px', '40px')}
          </div>
        </div>
      `;
    }
  };
})();
